var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDriverLicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.44,
    x2: 433.687,
    y1: 232.093,
    y2: 475.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 363.551,
    y2: 413.434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.121,
    x2: 483.344,
    xlinkHref: "#lg1",
    y1: 264.33,
    y2: 264.33
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.121,
    x2: 483.344,
    xlinkHref: "#lg1",
    y1: 316.603,
    y2: 316.603
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.121,
    x2: 380.268,
    xlinkHref: "#lg1",
    y1: 364.577,
    y2: 364.577
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.543,
    x2: 200.581,
    y1: 255,
    y2: 255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fa9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666ad6"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.628,
    x2: 90.794,
    xlinkHref: "#lg2",
    y1: 273.224,
    y2: 220.482
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.811,
    x2: 81.617,
    xlinkHref: "#lg2",
    y1: 359.124,
    y2: 272.272
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.577,
    x2: 119.577,
    xlinkHref: "#lg3",
    y1: 192.947,
    y2: 273.211
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.577,
    x2: 119.577,
    xlinkHref: "#lg3",
    y1: 289.491,
    y2: 358.097
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.545,
    x2: 251.545,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.863,
    x2: 288.863,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.355,
    x2: 314.355,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.971,
    x2: 340.971,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.414,
    x2: 377.414,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.173,
    x2: 412.173,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.611,
    x2: 249.611,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.787,
    x2: 276.787,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.208,
    x2: 308.208,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.147,
    x2: 348.147,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.022,
    x2: 388.022,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.834,
    x2: 428.834,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.648,
    x2: 468.648,
    xlinkHref: "#lg4",
    y1: 141.414,
    y2: 254.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m501.683 92.408h-493.366c-4.597 0-8.317 3.721-8.317 8.305v308.573c0 4.585 3.72 8.305 8.317 8.305h493.366c4.597 0 8.317-3.72 8.317-8.305v-308.573c0-4.584-3.72-8.305-8.317-8.305z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 328.011v81.275c0 4.585 3.72 8.305 8.317 8.305h493.366c4.597 0 8.317-3.72 8.317-8.305v-81.275z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m236.121 255.444h247.223v17.771h-247.223z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m236.121 307.718h247.223v17.771h-247.223z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m236.121 355.691h144.148v17.771h-144.148z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m190.852 375.836h-147.58c-5.373 0-9.729-4.356-9.729-9.729v-222.214c0-5.373 4.356-9.729 9.729-9.729h147.579c5.373 0 9.729 4.356 9.729 9.729v222.213c.001 5.374-4.355 9.73-9.728 9.73z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m153.611 182.945 46.974 46.974v130.734l-91.627-91.638-20.708-20.709c-9.182-8.459-14.927-20.579-14.927-34.037 0-25.543 20.709-46.263 46.251-46.263 13.459 0 25.578 5.757 34.037 14.939z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m166.56 287.639 34.025 34.049v44.415c0 5.379-4.36 9.727-9.738 9.727h-80.383l-55.741-55.682c5.841-26.36 27.344-46.808 54.237-51.133 3.471-.545 7.014-.841 10.615-.841 18.351 0 34.96 7.452 46.985 19.465z",
    fill: "url(#SVGID_8_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.576,
    cy: 214.272,
    fill: "url(#SVGID_9_)",
    r: 46.26
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m184.434 320.149c-16.518 16.743-39.479 27.11-64.858 27.11s-48.34-10.367-64.858-27.11c6.601-29.742 33.126-51.972 64.858-51.972 18.351 0 34.959 7.444 46.979 19.464 8.772 8.759 15.102 19.97 17.879 32.508z",
    fill: "url(#SVGID_10_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m236.225 176.849v-39.752c0-.79.395-1.476 1.186-2.06.79-.582 1.81-.873 3.058-.873h11.046c4.659 0 8.383 1.186 11.17 3.557 2.787 2.372 4.181 6.095 4.181 11.171v16.163c0 5.076-1.394 8.799-4.181 11.171-2.788 2.371-6.512 3.557-11.17 3.557h-11.046c-1.248 0-2.268-.291-3.058-.873-.791-.584-1.186-1.27-1.186-2.061zm9.735-5.554h5.554c3.744 0 5.616-2.08 5.616-6.24v-16.163c0-4.16-1.872-6.24-5.616-6.24h-5.554z",
    fill: "url(#SVGID_11_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m273.043 176.787v-39.689c0-.79.281-1.476.842-2.06.562-.582 1.279-.873 2.153-.873h12.918c10.234 0 15.352 4.452 15.352 13.355 0 6.49-2.518 10.713-7.551 12.668l7.613 13.792c.208.292.312.666.312 1.123 0 1.207-.655 2.351-1.966 3.432-1.31 1.083-2.694 1.623-4.15 1.623-1.457 0-2.496-.602-3.121-1.81l-8.549-16.6h-4.119v15.04c0 .957-.479 1.695-1.435 2.215-.958.521-2.101.78-3.432.78-1.332 0-2.476-.259-3.432-.78-.957-.521-1.435-1.259-1.435-2.216zm9.736-22.529h6.178c1.83 0 3.224-.446 4.181-1.341.956-.894 1.435-2.381 1.435-4.462 0-2.08-.479-3.567-1.435-4.462-.958-.894-2.351-1.342-4.181-1.342h-6.178z",
    fill: "url(#SVGID_12_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m309.488 176.787v-39.689c0-.957.478-1.685 1.435-2.184s2.101-.749 3.432-.749 2.475.25 3.432.749c.956.499 1.435 1.228 1.435 2.184v39.689c0 .957-.479 1.695-1.435 2.215-.958.521-2.101.78-3.432.78-1.332 0-2.476-.259-3.432-.78-.957-.52-1.435-1.258-1.435-2.215z",
    fill: "url(#SVGID_13_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m322.842 138.158c0-1.082.676-2.018 2.028-2.808 1.351-.79 2.755-1.186 4.212-1.186 1.788 0 2.849.604 3.182 1.81l8.737 32.014 8.674-32.014c.333-1.206 1.394-1.81 3.183-1.81 1.456 0 2.86.396 4.212 1.186 1.352.791 2.028 1.727 2.028 2.808 0 .125-.042.354-.125.686l-11.607 38.067c-.333 1.04-1.092 1.841-2.278 2.403-1.185.562-2.549.842-4.087.842-1.54 0-2.902-.281-4.087-.842-1.186-.562-1.945-1.362-2.278-2.403l-11.67-38.067c-.083-.332-.124-.561-.124-.686z",
    fill: "url(#SVGID_14_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m362.718 176.787v-39.627c0-.957.415-1.695 1.248-2.215.832-.52 1.83-.78 2.995-.78h22.216c.957 0 1.685.416 2.184 1.248.499.833.749 1.81.749 2.933 0 1.207-.26 2.226-.78 3.058-.521.833-1.238 1.248-2.153 1.248h-16.724v10.546h9.361c.915 0 1.632.374 2.153 1.123.52.749.78 1.644.78 2.683 0 .957-.25 1.81-.749 2.558-.499.749-1.227 1.123-2.184 1.123h-9.361v10.609h16.724c.915 0 1.632.416 2.153 1.248.52.833.78 1.852.78 3.058 0 1.123-.25 2.101-.749 2.933-.499.833-1.227 1.248-2.184 1.248h-22.216c-1.165 0-2.164-.259-2.995-.78-.833-.519-1.248-1.257-1.248-2.214z",
    fill: "url(#SVGID_15_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m396.353 176.787v-39.689c0-.79.281-1.476.843-2.06.562-.582 1.279-.873 2.153-.873h12.918c10.234 0 15.352 4.452 15.352 13.355 0 6.49-2.518 10.713-7.551 12.668l7.613 13.792c.208.292.312.666.312 1.123 0 1.207-.655 2.351-1.966 3.432-1.31 1.083-2.694 1.623-4.15 1.623-1.457 0-2.496-.602-3.121-1.81l-8.549-16.6h-4.119v15.04c0 .957-.479 1.695-1.435 2.215-.958.521-2.101.78-3.432.78-1.332 0-2.476-.259-3.432-.78-.958-.521-1.436-1.259-1.436-2.216zm9.735-22.529h6.178c1.83 0 3.224-.446 4.181-1.341.956-.894 1.435-2.381 1.435-4.462 0-2.08-.479-3.567-1.435-4.462-.958-.894-2.351-1.342-4.181-1.342h-6.178z",
    fill: "url(#SVGID_16_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m236.225 230.438v-39.689c0-.957.478-1.685 1.435-2.184s2.1-.749 3.432-.749c1.331 0 2.475.25 3.432.749s1.435 1.228 1.435 2.184v34.198h14.228c.874 0 1.56.416 2.059 1.248.499.833.749 1.831.749 2.996s-.25 2.164-.749 2.995c-.499.833-1.186 1.248-2.059 1.248h-19.72c-1.165 0-2.164-.259-2.995-.78-.832-.521-1.247-1.259-1.247-2.216z",
    fill: "url(#SVGID_17_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m271.92 230.438v-39.689c0-.957.478-1.685 1.435-2.184s2.1-.749 3.432-.749c1.331 0 2.475.25 3.432.749s1.435 1.228 1.435 2.184v39.689c0 .957-.479 1.695-1.435 2.215-.958.521-2.101.78-3.432.78-1.332 0-2.476-.259-3.432-.78-.958-.52-1.435-1.258-1.435-2.215z",
    fill: "url(#SVGID_18_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m292.887 219.08v-16.537c0-5.075 1.383-8.799 4.15-11.171 2.766-2.371 6.375-3.557 10.827-3.557 4.576 0 8.331 1.103 11.264 3.307 2.933 2.205 4.4 5.242 4.4 9.111 0 1.789-.374 3.006-1.123 3.651s-1.997.967-3.744.967c-3.12 0-4.743-.977-4.868-2.933-.125-3.744-1.977-5.616-5.554-5.616-3.744 0-5.617 2.081-5.617 6.24v16.537c0 4.16 1.893 6.24 5.679 6.24 1.164 0 2.131-.187 2.902-.562.769-.374 1.32-.946 1.654-1.716.333-.769.551-1.404.655-1.903.103-.499.197-1.186.281-2.059.166-1.955 1.768-2.933 4.805-2.933 1.788 0 3.058.323 3.807.967.749.646 1.123 1.862 1.123 3.651 0 4.036-1.467 7.219-4.4 9.548-2.933 2.33-6.688 3.495-11.264 3.495-4.452 0-8.061-1.186-10.827-3.557-2.767-2.371-4.15-6.094-4.15-11.17z",
    fill: "url(#SVGID_19_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m333.45 230.438v-39.627c0-.957.415-1.695 1.248-2.215.832-.52 1.83-.78 2.995-.78h22.216c.957 0 1.685.416 2.184 1.248.499.833.749 1.81.749 2.933 0 1.207-.26 2.226-.78 3.058-.521.833-1.238 1.248-2.153 1.248h-16.724v10.546h9.361c.915 0 1.632.374 2.153 1.123.52.749.78 1.644.78 2.683 0 .957-.25 1.81-.749 2.558-.499.749-1.227 1.123-2.184 1.123h-9.361v10.609h16.724c.915 0 1.632.416 2.153 1.248.52.833.78 1.852.78 3.058 0 1.123-.25 2.101-.749 2.933-.499.833-1.227 1.248-2.184 1.248h-22.216c-1.165 0-2.164-.259-2.995-.78-.833-.519-1.248-1.257-1.248-2.214z",
    fill: "url(#SVGID_20_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m372.078 230.438v-39.627c0-.957.478-1.695 1.435-2.215.956-.52 2.1-.78 3.432-.78 1.872 0 3.255.271 4.15.811.894.541 1.903 1.894 3.027 4.056l10.11 19.283v-21.218c0-.957.478-1.685 1.435-2.184s2.1-.749 3.432-.749c1.331 0 2.475.25 3.432.749s1.435 1.228 1.435 2.184v39.689c0 .957-.479 1.695-1.435 2.215-.957.521-2.101.78-3.432.78-2.663 0-4.473-.873-5.429-2.621l-11.857-21.592v21.218c0 .957-.479 1.695-1.435 2.215-.958.521-2.101.78-3.432.78-1.332 0-2.476-.259-3.432-.78-.958-.519-1.436-1.257-1.436-2.214z",
    fill: "url(#SVGID_21_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m413.514 225.945c0-1.164.426-2.33 1.279-3.495.852-1.164 1.841-1.747 2.964-1.747.624 0 1.32.252 2.091.757.769.505 1.476 1.064 2.122 1.677.645.614 1.549 1.173 2.715 1.677 1.164.505 2.392.757 3.682.757 1.622 0 3.036-.344 4.243-1.03 1.206-.686 1.81-1.716 1.81-3.089s-.676-2.579-2.028-3.62c-1.352-1.039-2.995-1.986-4.93-2.84-1.935-.852-3.88-1.81-5.835-2.871-1.956-1.061-3.61-2.568-4.961-4.524-1.352-1.955-2.028-4.284-2.028-6.989 0-4.41 1.56-7.707 4.68-9.891s6.885-3.276 11.295-3.276c1.081 0 2.215.064 3.401.193s2.517.376 3.994.74c1.476.365 2.683.954 3.619 1.768.936.815 1.404 1.801 1.404 2.958 0 1.1-.343 2.241-1.03 3.425s-1.633 1.776-2.839 1.776c-.499 0-1.56-.395-3.183-1.186-1.623-.79-3.412-1.186-5.367-1.186-2.081 0-3.641.365-4.68 1.092-1.04.729-1.56 1.613-1.56 2.652 0 .958.489 1.831 1.467 2.621.977.791 2.194 1.467 3.651 2.028 1.455.562 3.047 1.29 4.774 2.184 1.726.895 3.317 1.872 4.774 2.933 1.456 1.061 2.673 2.549 3.651 4.462.977 1.914 1.466 4.098 1.466 6.552 0 4.29-1.435 7.63-4.306 10.02s-6.636 3.584-11.295 3.584c-4.036 0-7.551-.832-10.546-2.496-2.997-1.663-4.494-3.535-4.494-5.616z",
    fill: "url(#SVGID_22_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m453.951 230.438v-39.627c0-.957.415-1.695 1.248-2.215.832-.52 1.83-.78 2.995-.78h22.216c.957 0 1.685.416 2.184 1.248.499.833.749 1.81.749 2.933 0 1.207-.26 2.226-.78 3.058-.521.833-1.238 1.248-2.153 1.248h-16.724v10.546h9.361c.915 0 1.632.374 2.153 1.123.52.749.78 1.644.78 2.683 0 .957-.25 1.81-.749 2.558-.499.749-1.227 1.123-2.184 1.123h-9.361v10.609h16.724c.915 0 1.632.416 2.153 1.248.52.833.78 1.852.78 3.058 0 1.123-.25 2.101-.749 2.933-.499.833-1.227 1.248-2.184 1.248h-22.216c-1.165 0-2.164-.259-2.995-.78-.832-.519-1.248-1.257-1.248-2.214z",
    fill: "url(#SVGID_23_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriverLicense);
export default __webpack_public_path__ + "static/media/icon-driver-license.fa77eb8057e00399c4b7246ff837c4bd.svg";
export { ForwardRef as ReactComponent };